import { Link } from "react-router-dom";
const Error401 = () => {
  return (
    <div className="gx-page-error-container">
      <div className="gx-page-error-content">
        <div className="gx-error-code">401</div>
        <h2 className="gx-text-center">
          <span> Bạn không có quyền với nội dung này.</span>
        </h2>

        <p style={{ textAlign: "center" }}>
          <Link className="gx-btn gx-btn-primary" to="/home">
            Quay lại trang chủ
          </Link>
        </p>
      </div>
    </div>
  );
};
export default Error401;
